// extracted by mini-css-extract-plugin
export var add = "popup-module--add--PYBAk";
export var message = "popup-module--message--ecdRq";
export var popup = "popup-module--popup--z6fAZ";
export var sub = "popup-module--sub--K83Mc";